import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Globe, ChevronDown } from 'lucide-react';
const languages = [{
  code: 'en',
  label: 'English',
  flag: '🇺🇸'
}, {
  code: 'fr',
  label: 'Français',
  flag: '🇫🇷'
}, {
  code: 'es',
  label: 'Español',
  flag: '🇪🇸'
}, {
  code: 'yo',
  label: 'Yorùbá',
  flag: '🇳🇬'
}];
export function LanguageToggle() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(languages[0]);
  return <div className="relative" data-id="element-248">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium text-gray-700" aria-label="Select language" data-id="element-249">
        <Globe className="w-4 h-4" data-id="element-250" />
        <span className="hidden sm:inline" data-id="element-251">{selected.flag}</span>
        <span className="hidden md:inline" data-id="element-252">{selected.label}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-253">
          <ChevronDown className="w-4 h-4" data-id="element-254" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-255">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} data-id="element-256" />
            <motion.div initial={{
          opacity: 0,
          y: -10,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: -10,
          scale: 0.95
        }} transition={{
          type: 'spring',
          duration: 0.3,
          bounce: 0.2
        }} className="absolute right-0 top-full mt-2 bg-white rounded-xl shadow-xl border border-gray-200 py-2 min-w-[160px] z-50" data-id="element-257">
              {languages.map(lang => <button key={lang.code} onClick={() => {
            setSelected(lang);
            setIsOpen(false);
          }} className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${selected.code === lang.code ? 'bg-emerald-50 text-emerald-700 font-semibold' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-258">
                  <span className="text-lg" data-id="element-259">{lang.flag}</span>
                  <span data-id="element-260">{lang.label}</span>
                </button>)}
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}